/** 렌더 순서. 표는 docs/architecture.md 8장에 있다. */
export const DEPTH = {
  sky: -100,
  farHill: -90,
  nearHill: -80,
  cloud: -70,
  ambient: -65,
  decor: -20,
  climbable: -15,
  portal: -10,
  terrain: 0,
  drop: 10,
  npc: 18,
  monster: 20,
  monsterHpBar: 25,
  remotePlayer: 28,
  player: 30,
  effect: 40,
  damageNumber: 50,
  mapTitle: 60,
} as const;
